import {fabric} from "fabric";
import _ from "lodash";
import { CutoffBorder } from "./cutOffBorder.js";
import {updateMask} from "./maskPainter";

export default class DieCut {
    listeners = null;
    maskService = null;
    store = null;
    canvas;

    strokeWidth;
    cutoffBorder;

    manipulatingObject = false;
    loading = false;

    constructor({maskService, store, strokeWidth = 8}) {
        this.maskService = maskService;
        this.store = store;
        this.canvas = store.canvas;

        this.strokeWidth = strokeWidth;

        this.onAttach();

        this.cutoffBorder = new CutoffBorder(this.canvas);
        this.cutoffBorder.cutoffBorder_attach();
    }

    update() {
        updateMask(this);
    }

    onAttach() {
        let app = this;
        let store = app.store;

        this.clearMask();
        updateMask(app);

        function onCanvasModified() {
            store.setLoadingFinished('processing.debouncedOnCanvasModified');

            updateMask(app);
        }

        const debouncedOnCanvasModified_short = _.debounce(onCanvasModified, 50);
        const debouncedOnCanvasModified_long = _.debounce(onCanvasModified, 600);
        const onCanvasModified_1000 = _.debounce(onCanvasModified, 200);

        const onManipulateObject = ()=> {
            app.manipulatingObject = true;
            app.clearMask();
        }

        const onObjectModified = (data)=> {
            app.clearMask();
            store.setLoading('processing.debouncedOnCanvasModified', '');

            if (data.target instanceof fabric.CurvedText && data.action === 'value-update') {
                onCanvasModified_1000();
                return;
            }

            if (data.target instanceof fabric.PdfObject) { //todo this is not the best solution
                debouncedOnCanvasModified_long();
                return;
            }

            debouncedOnCanvasModified_short();
        }

        app.listeners = {
            'object:added': (event)=> {
                if (event.target.type === 'PdfObject') {
                    return;
                }
                debouncedOnCanvasModified_short();
            },
            'object:modified' : onObjectModified,
            'object:removed': debouncedOnCanvasModified_short,
            'object:moving_start': onManipulateObject,
            'object:rotating_start': onManipulateObject,
            'object:scaling_start': onManipulateObject,
            'object:moving_end': ()=> app.manipulatingObject = false,
            'object:rotating_end': ()=> app.manipulatingObject = false,
            'object:scaling_end': ()=> app.manipulatingObject = false,
            'diecut:clear': ()=> {
                app.clearMask();
            },
        }
        store.canvas.on(app.listeners);
    }

    onDetach() {
        this.cutoffBorder.cutoffBorder_detach();

        if (this.listeners) {
            this.store.canvas.off(this.listeners);
        }
    }

    clearMask() {
        this.store.canvas.set({
            backgroundColor: null,
            backgroundImage: null,
        });
        this.store.canvas.set({clipPath: null});

    }
}

export function setDieCut({maskService, param}) {
    let app = maskService;
    if (app.oldMask !== param.type) {
        app.mask = new DieCut({
            maskService: maskService,
            store: app.store,
            strokeWidth: param.stroke_width,
        })
    } else {
        app.mask.strokeWidth = param.stroke_width;
        app.mask.update();
    }
}
